import React from 'react';
import {twMerge} from 'tailwind-merge';

export const labelStyles =
	'text-[13px] font-medium text-gray-600 dark:text-gray-300 flex items-center gap-1 select-none';

function Label({children, className, disabled, ...props}) {
	return (
		<label
			className={twMerge(
				labelStyles,
				disabled && 'text-gray-400 dark:text-gray-500',
				className,
			)}
			{...props}
		>
			{children}
		</label>
	);
}

export default Label;
